/**
 * Three nodes linked into a triangle — the constellation work's own mark,
 * rather than a generic network glyph.
 */
export default function ConstellationIcon({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <circle cx="12" cy="5" r="2.5" />
            <circle cx="5" cy="17" r="2.5" />
            <circle cx="19" cy="17" r="2.5" />
            <path d="M11 7.5 6.5 15" />
            <path d="M13 7.5 17.5 15" />
            <path d="M7.5 17h9" />
        </svg>
    );
}
